import CriticsAddActions from "components/Critics/AddActions"

import { ComponentProps } from "."

const AddActions = ({
  IMDb,
  imageSelector,
  screenshotSelector,
  isAddHomeVideoReviewEnabled,
  isAdmin,
  isEditor,
  label,
  loading,
  name,
  onAddHomeVideoReview,
  onClearAll,
  onNameChange,
  searchHomeVideo,
  techSpecsSelector
}: ComponentProps) => (
  <CriticsAddActions
    IMDb={IMDb}
    imageSelector={{ ...imageSelector, isMultiSelect: true }}
    isAddItemEnabled={isAddHomeVideoReviewEnabled}
    isAdmin={isAdmin}
    isEditor={isEditor}
    label={label}
    loading={loading}
    name={name}
    onAddItem={onAddHomeVideoReview}
    onClearAll={onClearAll}
    onNameChange={onNameChange}
    screenshotSelector={
      screenshotSelector
        ? { ...screenshotSelector, isMultiSelect: true }
        : undefined
    }
    searchHomeVideo={searchHomeVideo}
    serviceType="reviews"
    techSpecsSelector={techSpecsSelector}
  />
)

export default AddActions
